import { ApiUrls } from '@api/api.urls';
import { makeAxiosRequest } from '@api/apiUtils/makeAxiosRequest';

import type { CurrentUserFetchResponse } from '@api/users/api.users.types';

export const retrieveActiveUser = () => {
  return makeAxiosRequest<CurrentUserFetchResponse>({
    url: ApiUrls.users.activeUser,
    method: 'get',
  });
};
